import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M12 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0M4 6h8M16 6h4M6 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0M4 12h2M10 12h10M15 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0M4 18h11M19 18h1" })
    ], -1 /* CACHED */),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1 /* CACHED */)
  ]))]))
}
export default { render: render }